import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.pos.orders');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-pos-orders',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.pos.orders/view.scss */
:host {
  display: block;
  height: 100%;
}

.sub-screen {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--pos-bg);
  color: var(--pos-text);
  padding: 16px;
  gap: 12px;
}

.sub-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: var(--pos-radius);
  box-shadow: var(--pos-shadow);
}
.sub-header h2 {
  flex: 1;
  margin: 0;
  font-size: 17px;
  font-weight: 800;
}

.back-btn, .icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--pos-card);
  border: 1px solid var(--pos-border);
  color: var(--pos-text-dim);
  border-radius: var(--pos-radius-sm);
  cursor: pointer;
}
.back-btn:hover, .icon-btn:hover {
  background: var(--pos-hover);
  color: var(--pos-text);
}

.back-btn {
  width: 36px;
  height: 32px;
}

.icon-btn {
  width: 30px;
  height: 28px;
}

.header-stats {
  display: flex;
  gap: 8px;
}

.stat-chip {
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  border-radius: var(--pos-radius-sm);
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 700;
}

.tab-nav {
  display: flex;
  gap: 8px;
  min-height: 42px;
}

.tab-btn {
  padding: 0 18px;
  border: 1px solid var(--pos-border);
  border-radius: var(--pos-radius-sm);
  background: var(--pos-panel);
  color: var(--pos-text-dim);
  font-weight: 700;
  cursor: pointer;
}
.tab-btn.active {
  background: var(--pos-accent);
  border-color: var(--pos-accent);
  color: #fff;
}

.message-bar {
  padding: 10px 12px;
  border: 1px solid rgba(52, 199, 89, 0.35);
  background: var(--pos-success-bg);
  color: #73d88b;
  border-radius: var(--pos-radius-sm);
  font-size: 13px;
}

.sub-body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.panel-grid {
  display: grid;
  grid-template-columns: minmax(320px, 0.9fr) minmax(420px, 1.2fr);
  gap: 12px;
  height: 100%;
  min-height: 0;
}
.panel-grid .full {
  grid-column: 1/-1;
}

.work-panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: var(--pos-radius);
  padding: 14px;
  gap: 12px;
  box-shadow: var(--pos-shadow);
}
.work-panel h3 {
  margin: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--pos-border);
  font-size: 15px;
  font-weight: 800;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: var(--pos-text-dim);
  font-size: 12px;
  font-weight: 700;
}
.field.wide {
  grid-column: 1/-1;
}

input, select {
  height: var(--pos-field-height);
  border-radius: var(--pos-radius-sm);
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  padding: 0 10px;
  outline: none;
}

.item-entry {
  display: grid;
  grid-template-columns: 1.3fr 1.2fr 0.7fr 0.6fr 0.8fr auto;
  gap: 8px;
  align-items: center;
}

.primary-btn, .small-btn {
  border: 1px solid transparent;
  border-radius: var(--pos-radius-sm);
  font-weight: 800;
  cursor: pointer;
}

.primary-btn {
  height: var(--pos-control-height);
  padding: 0 16px;
  background: var(--pos-accent);
  color: #fff;
}

.small-btn {
  height: 30px;
  padding: 0 10px;
  background: var(--pos-card);
  color: var(--pos-text);
  border-color: var(--pos-border);
}
.small-btn.danger {
  color: var(--pos-red);
  background: var(--pos-danger-bg);
}
.small-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.action-row {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.table-wrap {
  flex: 1;
  min-height: 0;
  overflow: auto;
  border: 1px solid var(--pos-border);
  border-radius: var(--pos-radius-sm);
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 640px;
}
.data-table th, .data-table td {
  padding: 9px 10px;
  border-bottom: 1px solid var(--pos-border);
  font-size: 13px;
  white-space: nowrap;
}
.data-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--pos-table-header);
  color: var(--pos-text-dim);
  text-align: left;
  font-size: 12px;
  font-weight: 800;
}
.data-table tbody tr {
  cursor: default;
}
.data-table tbody tr:hover {
  background: var(--pos-hover);
}
.data-table tbody tr.selected {
  background: var(--pos-selected);
}
.data-table tbody tr.warn {
  background: var(--pos-warning-bg);
}
.data-table tfoot td {
  background: var(--pos-card);
  font-weight: 800;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.actions {
  display: flex;
  gap: 6px;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  background: var(--pos-warning-bg);
  color: #ffb340;
  font-size: 12px;
  font-weight: 800;
}
.status-pill.done {
  background: var(--pos-success-bg);
  color: #73d88b;
}

.detail-strip {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 40px;
  padding: 8px 10px;
  border-radius: var(--pos-radius-sm);
  background: var(--pos-card);
  border: 1px solid var(--pos-border);
}

.detail-title {
  color: var(--pos-text-dim);
  font-size: 12px;
  font-weight: 800;
}

.detail-item {
  padding: 4px 8px;
  border-radius: var(--pos-radius-sm);
  background: var(--pos-panel);
  font-size: 12px;
}

@media (max-width: 960px) {
  .panel-grid {
    grid-template-columns: 1fr;
    overflow: auto;
  }
  .item-entry {
    grid-template-columns: 1fr 1fr;
  }
  .header-stats {
    display: none;
  }
}`],
})
export class PagePosOrdersComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) {}

    public tabs = ['발주등록', '발주현황', '재고관리', '거래처관리'];
    public activeTab = '발주등록';
    public suppliers: any[] = [];
    public inventory: any[] = [];
    public orders: any[] = [];
    public selectedOrder: any = null;
    public message = '';

    public supplierForm: any = { id: '', name: '', phone: '', manager: '', memo: '' };
    public inventoryForm: any = { id: '', name: '', unit: '개', stock: 0, safetyStock: 0, supplierId: 0 };
    public orderForm: any = { supplierId: 0, expectedDate: '', memo: '' };
    public orderItems: any[] = [];
    public newOrderItem: any = { inventoryId: 0, name: '', qty: 1, unit: '개', price: 0 };

    public async ngOnInit() {
        await this.service.init();
        this.setDefaultDate();
        await this.load();
        await this.service.render();
    }

    private setDefaultDate() {
        const now = new Date();
        now.setDate(now.getDate() + 1);
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, '0');
        const d = String(now.getDate()).padStart(2, '0');
        this.orderForm.expectedDate = `${y}-${m}-${d}`;
    }

    public async load() {
        const res = await wiz.call('load');
        if (res.code === 200) {
            this.suppliers = res.data.suppliers || [];
            this.inventory = res.data.inventory || [];
            this.orders = res.data.orders || [];
            if (!this.orderForm.supplierId && this.suppliers.length) {
                this.orderForm.supplierId = this.suppliers[0].id;
            }
        }
    }

    public async switchTab(tab: string) {
        this.activeTab = tab;
        this.message = '';
        await this.service.render();
    }

    get lowStockCount(): number {
        return this.inventory.filter((i: any) => Number(i.stock) <= Number(i.safety_stock)).length;
    }

    get pendingOrderCount(): number {
        return this.orders.filter((o: any) => o.status !== '입고완료').length;
    }

    get orderTotal(): number {
        return this.orderItems.reduce((sum: number, item: any) => sum + Number(item.qty || 0) * Number(item.price || 0), 0);
    }

    public goBack() {
        this.service.href('/pos');
    }

    public selectInventoryForOrder() {
        const item = this.inventory.find((i: any) => Number(i.id) === Number(this.newOrderItem.inventoryId));
        if (!item) return;
        this.newOrderItem.name = item.name;
        this.newOrderItem.unit = item.unit;
        this.service.render();
    }

    public async addOrderItem() {
        if (!this.newOrderItem.name) return;
        this.orderItems.push({
            inventoryId: Number(this.newOrderItem.inventoryId || 0),
            name: this.newOrderItem.name,
            qty: Number(this.newOrderItem.qty || 1),
            unit: this.newOrderItem.unit || '개',
            price: Number(this.newOrderItem.price || 0),
        });
        this.newOrderItem = { inventoryId: 0, name: '', qty: 1, unit: '개', price: 0 };
        await this.service.render();
    }

    public async removeOrderItem(idx: number) {
        this.orderItems.splice(idx, 1);
        await this.service.render();
    }

    public async saveOrder() {
        if (!this.orderItems.length) {
            this.message = '발주 품목을 추가하세요.';
            await this.service.render();
            return;
        }
        const res = await wiz.call('save_order', {
            supplierId: this.orderForm.supplierId,
            expectedDate: this.orderForm.expectedDate,
            memo: this.orderForm.memo,
            items: JSON.stringify(this.orderItems),
        });
        this.message = res.code === 200 ? '발주가 등록되었습니다.' : (res.data?.message || '발주 등록에 실패했습니다.');
        if (res.code === 200) {
            this.orderItems = [];
            this.orderForm.memo = '';
            await this.load();
            this.activeTab = '발주현황';
        }
        await this.service.render();
    }

    public async selectOrder(order: any) {
        this.selectedOrder = this.selectedOrder?.id === order.id ? null : order;
        await this.service.render();
    }

    public async receiveOrder(order: any) {
        const res = await wiz.call('receive_order', { id: order.id });
        this.message = res.code === 200 ? '입고 처리되었습니다.' : (res.data?.message || '입고 처리에 실패했습니다.');
        await this.load();
        await this.service.render();
    }

    public async deleteOrder(order: any) {
        const res = await wiz.call('delete_order', { id: order.id });
        this.message = res.code === 200 ? '발주가 삭제되었습니다.' : (res.data?.message || '삭제에 실패했습니다.');
        await this.load();
        await this.service.render();
    }

    public editInventory(item: any) {
        this.inventoryForm = {
            id: item.id,
            name: item.name,
            unit: item.unit,
            stock: item.stock,
            safetyStock: item.safety_stock,
            supplierId: item.supplier_id || 0,
        };
        this.activeTab = '재고관리';
        this.service.render();
    }

    public async saveInventory() {
        const res = await wiz.call('save_inventory', this.inventoryForm);
        this.message = res.code === 200 ? '재고 품목이 저장되었습니다.' : (res.data?.message || '재고 저장에 실패했습니다.');
        if (res.code === 200) {
            this.inventoryForm = { id: '', name: '', unit: '개', stock: 0, safetyStock: 0, supplierId: 0 };
            await this.load();
        }
        await this.service.render();
    }

    public editSupplier(supplier: any) {
        this.supplierForm = { ...supplier };
        this.activeTab = '거래처관리';
        this.service.render();
    }

    public async saveSupplier() {
        const res = await wiz.call('save_supplier', this.supplierForm);
        this.message = res.code === 200 ? '거래처가 저장되었습니다.' : (res.data?.message || '거래처 저장에 실패했습니다.');
        if (res.code === 200) {
            this.supplierForm = { id: '', name: '', phone: '', manager: '', memo: '' };
            await this.load();
        }
        await this.service.render();
    }

    public async deleteSupplier(supplier: any) {
        const res = await wiz.call('delete_supplier', { id: supplier.id });
        this.message = res.code === 200 ? '거래처가 비활성화되었습니다.' : (res.data?.message || '거래처 삭제에 실패했습니다.');
        await this.load();
        await this.service.render();
    }

    public formatCurrency(value: number): string {
        return Number(value || 0).toLocaleString();
    }
}

export default PagePosOrdersComponent;